import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

export const CURRENT_USER_FRAGMENT = gql`
  fragment currentUser on User {
    _id
    emails {
      address
      verified
    }
    roles
    profile {
      firstName
      lastName
    }
  }
`;

export const ME_QUERY = gql`
  query me {
    me {
      ...currentUser
    }
  }
  ${CURRENT_USER_FRAGMENT}
`;

export default function useUser() {
  const { loading, error, data, refetch } = useQuery(ME_QUERY);
  return [data?.me, loading, error, refetch];
}
